import PropTypes from "prop-types";
import Icon from "@mui/material/Icon";

// Soft UI Components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Helper to format date
function formatDate(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  return d.toLocaleString("ro-RO", { dateStyle: "short", timeStyle: "short" });
}

// Helper to build action description
function buildAction(item) {
  const changes = [];
      changes.push(
        `Redirectionare: ${item.redirect_from} → ${item.redirect_to}`
      );
  
  if (item.redirect_reason) {
    changes.push(`Motiv: ${item.redirect_reason}`);
  }
  if (changes.length === 0 && item.status) {
    changes.push(`Status: ${item.status}`);
  }
  return changes.join(" | ");
}

export default function ReportRedirection({ redirections, isMobile }) {
  return (
    <SoftBox p={2}>
      <SoftBox 
        p={2} 
        border="1px solid #eee" 
        borderRadius="lg" 
        bgcolor="#f8f9fa"
      >
        <SoftTypography variant="subtitle2" fontWeight="medium" mb={2}>
          Redirectionari
        </SoftTypography>
        <SoftBox sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          {redirections.map((item, index) => (
            <SoftBox
              key={item.history_id || index}
              sx={{ display: "flex", alignItems: "center", flexWrap: isMobile ? "wrap" : "nowrap" }}
            >
              <SoftBox 
                sx={{ 
                  width: 8, 
                  height: 8, 
                  borderRadius: "50%", 
                  bgcolor: "info.main",
                  mr: 1.5,
                  flexShrink: 0
                }} 
              />
              <SoftTypography
                variant="caption"
                fontWeight="medium"
                width={isMobile ? "100%" : "120px"}
                sx={{ mb: isMobile ? 0.5 : 0 }}
              >
                {formatDate(item.created_at)}
              </SoftTypography>
              <SoftTypography variant="body2" sx={{ ml: 1 }}>
                {buildAction(item)}
              </SoftTypography>
            </SoftBox>
          ))}
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
}

ReportRedirection.propTypes = {
  timeline: PropTypes.arrayOf(
    PropTypes.shape({
      created_at: PropTypes.string,
      redirect_from: PropTypes.string,
      redirect_reason: PropTypes.string,
      redirect_to: PropTypes.string,
    })
  ).isRequired,
  isMobile: PropTypes.bool
};
